import { i18n } from '../../i18n/translate.js';

var everfiAdminNavigation = function everfiAdminNavigation() {
  var environment = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    MENU_DOMAIN_FOR_ADMINIFI: ''
  };
  var MENU_DOMAIN_FOR_ADMINIFI = environment.MENU_DOMAIN_FOR_ADMINIFI;
  return {
    id: 'foundry--universal_navigation--menus--everfi_admin_navigation',
    type: 'menus',
    slug: 'foundry--universal_navigation--menus--everfi_admin_navigation',
    title: '',
    icon: '',
    font_family: '',
    css_class: '',
    target_url: '',
    target_method: '',
    new_window: false,
    subsection: false,
    weight: 100,
    submenu_items: [{
      id: '',
      slug: 'help',
      title: i18n.t('Help'),
      icon: 'circle-question',
      font_family: '',
      css_class: '',
      target_url: "https://help.everfi.com/s/help",
      target_method: '',
      new_window: true,
      subsection: false,
      submenu_items: [],
      weight: 100
    }, {
      id: 'account',
      slug: 'account',
      title: '{{user_name}}',
      icon: 'circle-user',
      font_family: '',
      css_class: 'account',
      target_url: '',
      target_method: '',
      new_window: false,
      subsection: true,
      weight: 99,
      submenu_items: [{
        id: '',
        slug: 'logout',
        title: i18n.t('Logout'),
        icon: '',
        font_family: '',
        css_class: '',
        target_url: "".concat(MENU_DOMAIN_FOR_ADMINIFI, "/admin/session"),
        target_method: 'GET',
        new_window: false,
        subsection: false,
        submenu_items: [],
        weight: 100
      }]
    }]
  };
};

export { everfiAdminNavigation };